import React from 'react';

export default function Footer() {
    return (
        <footer className="text-brand-white body-font container px-5 py-2 mx-auto flex items-center justify-center sm:flex-row flex-col">
             <p className="text-sm text-brand-white sm:ml-4 sm:pl-4 sm:py-2 sm:mt-0 mt-4">Made with ❤️ —
                        <a href="https://github.com/peterWorakarn" className="text-brand-white ml-1" rel="noopener noreferrer" target="_blank">Peter Oun</a>
                    </p>
        </footer>
    )
}
